import { onMounted, ref} from "@vue/composition-api"
import { chartData, chartDownload, dashboardDetail } from '../api/index';
import { fillerConfig, fillterSelectList, createFilterForm, queryConditions } from '../filter';
import { cloneDeep } from "lodash-es";
import { handleErrorMessageToast } from '@/common/util';
import { formatTimeSecs } from '@/common/time';
import {
    NewSelectorConfigType,
    ChartLineDataType,
    FilterFormItemType,
    ChartsType,
    ConditionsType,
    SelectorsType
} from '../types';


export const colorArray = [
    '#376DF7',
    '#53B997',
    '#6750AA',
    '#F8C541',
    '#294680',
    '#68B2FF',
    '#7A4388',
    '#E883B9',
    '#00827F',
    '#FF9B47',
    '#FE3666',
    '#ed6707',
    '#ed079c',
    '#9739bd',
    '#4641e0',
    '#41dbe0',
    '#41e071'
]

export function useOriginData(props: any, content: any) {
    const dashboardData = ref();
    const newCorePannelLineConfig = ref<NewSelectorConfigType | null>(null); // 过滤生成新的核心概览-折线图 config
    const newCorePannelBarConfig = ref<NewSelectorConfigType | null>(null); // 过滤生成新的核心概览-饼状图 config
    const corePannelLineChartData = ref<ChartLineDataType | null>(null) // 折线图数据
    const corePannelBarChartData = ref<ChartLineDataType | null>(null) // 折线图数据
    const fillterForm = ref<FilterFormItemType[]>([]); // chart的查询条件
    const selectList = ref<ConditionsType[]>([]); // select 类型筛选项List
    const chartLoading = ref(false); // 折线图loading
    const tableData = ref<ChartLineDataType | null>(null); // 表格数据
    const tableConfig = ref<ChartsType>(); // 表格 config
    const downLoading = ref(false);

    // 获取饼图数据
    async function getBarChart(origin: string[], index: string) {
        chartLoading.value = true;
        // 追加data_from 参数
        const conditionOrigin = [{fieldName: 'data_from', fieldValue: origin.join(',')}];
        const conditionsQuery = [...queryConditions(cloneDeep(fillterForm.value)), ...conditionOrigin];
        
        const params =  {
            chartId: newCorePannelBarConfig.value!.chartId,
            selector: [ 'p_date', 'minigame_from_v2_1_level_name', index],
            conditions: conditionsQuery,
            granularity: "day",
            sorts: [] as [],
            offset: 0
        }
        try {
            const res = await chartData(params);
            if(res.data.result === 1) {
                corePannelBarChartData.value = res.data.data;
                chartLoading.value = false;
            } else {
                handleErrorMessageToast(res.data.msg || res.data.error_msg || '系统异常');
                chartLoading.value = false;
            }
        } catch(err) {
            handleErrorMessageToast(err.error_msg || err.msg ||'系统异常，请稍后再试')
            chartLoading.value = false;
        }
    }

    // 获取折线图chart Data
    async function getCorePannelLineChart(origin: string[], index: string) {
        chartLoading.value = true;
        const conditionOrigin = [{fieldName: 'data_from', fieldValue: origin.join(',')}];
        const conditionsQuery = [...queryConditions(cloneDeep(fillterForm.value)), ...conditionOrigin];
        
        const params =  {
            chartId: newCorePannelLineConfig.value!.chartId,
            selector: [ 'p_date', 'minigame_from_v2_1_level_name', index],
            conditions: conditionsQuery,
            granularity: "day",
            sorts: [] as [],
            offset: 0
        }
        try {
            const res = await chartData(params);
            if(res.data.result === 1) {
                corePannelLineChartData.value = res.data.data;
                // 补充颜色
                corePannelLineChartData.value.titles.map((m, i) => {
                    if(m.fieldName !== 'p_date') {
                        m.displaySetting = `{"color":"${colorArray[i]}"}`
                    }
                })
                chartLoading.value = false;
            } else {
                handleErrorMessageToast(res.data.msg || res.data.error_msg || '系统异常');
                chartLoading.value = false;
            }
        } catch(err) {
            handleErrorMessageToast(err.error_msg || err.msg ||'系统异常，请稍后再试')
            chartLoading.value = false;
        }
    }


    // 获取【总览】的所有配置项
    async function getDashboard()  {
        try {
            const { data } = await dashboardDetail('fromAnalysis');
            if(data.result === 1) {
                dashboardData.value = data.data;
                selectList.value = fillterSelectList(data.data.conditions);
                // 生成默认的查询条件
                fillterForm.value = createFilterForm(data.data.conditions, props.appId);
                // fillterForm.value = createFilterForm(data.data.conditions, 'ks652458996766419301');
                // 核心概览pannel TODO: 先暂时用0，因为配置上顺序是固定的，不可更改的，后续看是否有其他方法
                const corePannel = data.data.panels[0]

                // 根据游戏类型组合成新的核心概览-line config
                newCorePannelLineConfig.value = fillerConfig(corePannel.charts.find((item: ChartsType) => item.chartCode === 'dataFromOverviewLine')!, props.gameType);
                newCorePannelBarConfig.value = fillerConfig(corePannel.charts.find((item: ChartsType) => item.chartCode === 'dataFromOverviewPie')!, props.gameType);
                tableConfig.value = corePannel.charts.find((item: ChartsType) => item.chartCode === 'summaryDataTable')

            } else {
                handleErrorMessageToast(data.msg || data.error_msg || '系统异常');
            }

        } catch(err) {
            console.log(err)
            handleErrorMessageToast(err.error_msg || err.msg ||'系统异常，请稍后再试')
        }
    }

    // 获取表格chart
    async function getTableChart() {
        if(!tableConfig.value) return handleErrorMessageToast('未获取到相应配置');

        const chartTableItem = tableConfig.value;
        // 筛选条件
        const conditionsQuery = queryConditions(cloneDeep(fillterForm.value));
        // 需要展示的selectors
        const selectors =  chartTableItem.selectors.map((item: SelectorsType) => item.fieldName);
        const params =  {
            chartId: chartTableItem.chartId,
            selector: selectors.filter(m => m !== 'p_date' && m !== 'app_id'),
            conditions: conditionsQuery,
            granularity: "day",
            sorts: [] as [],
            limit: 150,
            offset: 0
        }
        try {
            const res = await chartData(params);
            if(res.data.result === 1) {
                tableData.value = res.data.data;
                tableData.value.records.map(m => {
                    m.sub_avg_game_duration_time = formatTimeSecs(Number(m.sub_avg_game_duration_time))
                })
            } else {
                handleErrorMessageToast(res.data.msg || res.data.error_msg || '系统异常');
            }

        } catch(error) {
            handleErrorMessageToast(error.error_msg || error.msg ||'系统异常，请稍后再试')
        }
    }

    // 下载表格
    async function tableDownload() {
        if(!tableConfig.value) {
            handleErrorMessageToast('未获取到相应配置');
            return;
        }
        downLoading.value = true;

        // 当前请求的chart 相关配置
        const chartTableItem = tableConfig.value;

        if(!chartTableItem) {
            handleErrorMessageToast('未获取到相应配置：chartId');
            return;
        }
        // 筛选条件
        const conditionsQuery = queryConditions(cloneDeep(fillterForm.value));
        // 需要展示的selectors
        const selectors =  chartTableItem.selectors.map((item: SelectorsType) => item.fieldName);
        const params =  {
            chartId: chartTableItem.chartId,
            selector: selectors.filter(m => m !== 'p_date' && m !== 'app_id'),
            conditions: conditionsQuery,
            granularity: "day",
            sorts: [] as [],
            limit: 150,
            offset: 0
        }
        try {
            const res = await chartDownload(params);
            downLoading.value = false;
            if(res.data.result === 1) {
                window.location.href = res.data.data.url;
            } else {
                handleErrorMessageToast(res.data.msg || res.data.error_msg || '系统异常');
            }
        } catch(error) {
            downLoading.value = false;
            handleErrorMessageToast(error.error_msg || error.msg ||'系统异常，请稍后再试')
        }
    }


    onMounted(async () => {
        // 获取dashboard,其余接口会在dashbord结果返回后触发vue 里的watch，再请求
        getDashboard()
    })

    return {
        newCorePannelLineConfig,
        fillterForm,
        dashboardData,
        corePannelLineChartData,
        corePannelBarChartData,
        selectList,
        chartLoading,
        getDashboard,
        getCorePannelLineChart,
        getBarChart,
        getTableChart,
        tableData,
        downLoading,
        tableDownload,
    }
}